import React, { Component, Fragment } from 'react';
import {
    Button,
    Checkbox,
    Divider,
    Form,
    Grid,
    Header,
    Icon,
    Input,
    Popup,
    Segment,
    Table,
    Message,
    Loader
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { IconHeader } from '../../Assets/util/css';
import { FormattedMessage } from 'react-intl';

class SemesterTransferSemesters extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            filterData: JSON.parse(localStorage.getItem('filterData')),
            studentSemesters: [],
            studentSemestersForSecondStudent: [],
            checkedSemesters: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.transferSemesters = this.transferSemesters.bind(this);
        this.fetchStudentSemesters = this.fetchStudentSemesters.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.checkAll = this.checkAll.bind(this);
    }

    componentDidMount() {
        let student = JSON.parse(localStorage.getItem('student'));
        this.fetchStudentSemesters(student.id);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
            secondStudent: true
        }, () => {
            this.fetchStudentSemesters(value.id, true);
        });
    }

    fetchStudentSemesters(studentStudyProgramId, secondStudent = false) {
        let student = JSON.parse(localStorage.getItem('student'));
        axios.get(`students/${studentStudyProgramId}/semesters/overview-for-admin/`)
            .then(res => {
                let studentSemesters = [];
                if (res.data.find(e => e.semester.name.name === 'ostalo') || student.gradStudentAcademicYearId) {
                    studentSemesters = [{
                        semester: {
                            academicYear: {
                                id: res.data.find(e => e.semester.name.name === 'ostalo') ?
                                    res.data.find(e => e.semester.name.name === 'ostalo').semester.academicYear.id
                                    : student.gradStudentAcademicYearId,
                                name: res.data.find(e => e.semester.name.name === 'ostalo') ?
                                    res.data.find(e => e.semester.name.name === 'ostalo').semester.academicYear.name
                                    : student.gradStudentAcademicYearName,
                            },
                            name: { name: 'Apsolventski staž' }
                        },
                        studyProgramSemester: {
                            name: ''
                        },
                        studyTypeId: null,
                        studentStatusId: null
                    }];

                    console.log('studentSemesters', studentSemesters);
                }
                if (secondStudent) {
                    this.setState({
                        checkedSemesters: [],
                        studentSemestersForSecondStudent: [...studentSemesters, ...res.data]
                    });
                } else {
                    this.setState({
                        checkedSemesters: [],
                        studentSemesters: [...studentSemesters, ...res.data]
                    });
                }
            })
            .catch(err => {
                toast('Došlo je do greške. Nije moguće dobaviti semestre.');
            });
    }

    handleCheckboxChange(id, checked) {
        if (checked) {
            this.setState({
                checkedSemesters: [...this.state.checkedSemesters, id]
            });
        } else {
            const filtered = this.state.checkedSemesters.filter(el => el !== id);
            this.setState({
                checkedSemesters: filtered,
            });
        }
    }


    transferSemesters() {
        this.setState({ newStudyProgramErr: false, checkedSemestersErr: false });
        let student = JSON.parse(localStorage.getItem('student'));
        let { newStudyProgram, checkedSemesters } = this.state;
        if (!newStudyProgram || checkedSemesters.length === 0) {
            if (!newStudyProgram) { toast('Niste odabrali studenta!'); this.setState({ newStudyProgramErr: true }); } else { this.setState({ newStudyProgramErr: false }); }
            if (checkedSemesters.length === 0) { toast('Niste odabrali semestre!'); this.setState({ checkedSemestersErr: true }); } else { this.setState({ checkedSemestersErr: false }); }
        } else {
            this.setState({ loader: true });

            let obj = {
                wrongStudentStudyProgramId: student.id,
                correctStudentStudyProgramId: newStudyProgram.id,
                studyProgramSemesterIds: checkedSemesters
            };
            axios.put('students/change-ssp-for-ssps', { ...obj })
                .then(res => {
                    this.setState({ loader: false });
                    toast('Uspješno ste prebacili semestre.!');
                    this.fetchStudentSemesters(student.id);
                    this.fetchStudentSemesters(newStudyProgram.id, true);
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Both ssp must be from the same spb!') {
                        toast('Prebacivanje semestara je moguće samo ako se vrši sa istog smjera.');
                    } else if (err.response.data === 'Both ssp must be for the same student!') {
                        toast('Prebacivanje semestara je moguće samo ako se vrši za istog studenta.');
                    } else if (err.response.data === 'Invalid ssps ids sent!') {
                        toast('Odabrani semestri nisu ispravni.');
                    } else if (err.response.data === 'Could not change ssp for passed semesters!') {
                        toast('Došlo je do greške! Prebacivanje semestara nije izvršeno.');
                    } else {
                        toast('Došlo je do greške! Prebacivanje semestara nije izvršeno.');
                    }
                });
        }
    }

    checkAll(checked) {
        this.setState({ checkAllFlag: !this.state.checkAllFlag });
        if (!checked) {
            this.setState({ checkedSemesters: [] });
        } else {
            this.setState({ checkedSemesters: this.state.studentSemesters.map((el) => el.studentStudyProgramSemesterId) });
        }
    }

    render() {
        let candidateDisplayName = this.state.student.firstName + ' ' + this.state.student.lastName + '  |  ' + this.state.student.studyProgramName;
        const {
            filterData, checkedSemesters, checkAllFlag, studentSemestersForSecondStudent, studentSemesters, newStudyProgram
        } = this.state;
        return (
            <div>
                <h1>Prebacivanje semestara</h1>
                <div>
                    <Segment.Group raised>
                        <Segment>
                            <Header as="h3">
                                Odabir semestara
                                <Header floated="right" style={IconHeader}>
                                    <Popup
                                        floatd="right"
                                        trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                        content="Vrati"
                                        hideOnScroll
                                        position="top center"
                                    />
                                </Header>
                            </Header>
                        </Segment>
                        <Segment clearing>
                            <Grid columns={2}>
                                <Divider vertical>
                                    <Icon name="long arrow alternate right" />
                                </Divider>

                                <Grid.Column>
                                    <Form>
                                        <Segment>
                                            <Form.Group widths="equal">

                                                <Form.Field required>
                                                    <label>
                                                        Student | Studijski program sa kojeg se prebacuju semestri
                                                    </label>
                                                    <input
                                                        required
                                                        fluid
                                                        disabled
                                                        placeholder="Ime i prezime studenta, studijski program"
                                                        control={Input}
                                                        name="oldStudyProgram"
                                                        value={candidateDisplayName}
                                                    />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                </Grid.Column>

                                <Grid.Column>
                                    <Form>
                                        <Segment>
                                            <Form.Group widths="equal">
                                                <Form.Field required error={this.state.newStudyProgramErr}>
                                                    <label>
                                                        Student | Studijski program na koji se prebacuju semestri
                                                    </label>
                                                    <Form.Dropdown
                                                        placeholder="Ime i prezime studenta, index, studijski program"
                                                        search
                                                        fluid
                                                        selection
                                                        options={filterData.filter(e => e.studentId === this.state.student.studentId && e.id !== this.state.student.id)}
                                                        onChange={this.handleInputChange}
                                                        value={this.state.newStudyProgram}
                                                        name="newStudyProgram"
                                                        clearable

                                                    />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                    </Form>

                                </Grid.Column>
                            </Grid>
                        </Segment>
                        <Segment>
                            {this.state.loader ?
                                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                : <Grid columns={2}>
                                    <Divider vertical>
                                        <Icon name="long arrow alternate right" />
                                    </Divider>
                                    <Grid.Column>
                                        <Table celled selectable compact size="small">
                                            <Table.Header>
                                                <Table.Row>

                                                    <Table.HeaderCell colSpan={6}>Semestar (akademska godina)</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={4}>Broj semestra</Table.HeaderCell>
                                                    <Table.HeaderCell width={1} verticalAlign="middle" textAlign="center" >
                                                        <Header as="h5">
                                                            <Popup
                                                                content="Označi sve"
                                                                position="top center"
                                                                trigger={
                                                                    <Form>
                                                                        <Form.Field error={this.state.checkedSemestersErr}>
                                                                            <Checkbox

                                                                                checked={checkAllFlag}
                                                                                onChange={(e, { checked }) => { this.checkAll(checked); }}
                                                                            />
                                                                        </Form.Field>
                                                                    </Form>
                                                                }
                                                            />
                                                            {/* <Header.Subheader>Označi sve</Header.Subheader> */}
                                                        </Header>


                                                    </Table.HeaderCell>

                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body> {studentSemesters.sort((a, b) => b.semester.academicYear.id - a.semester.academicYear.id).filter(e => e.semester.name.name !== 'ostalo').map((el, index) =>
                                                (<Table.Row key={index}>


                                                    <Table.Cell verticalAlign="middle" colSpan={6} >
                                                        {el.semester.name.name} ({el.semester.academicYear.name})
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" colSpan={4}>
                                                        {el.studyProgramSemester.name}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                                        <Form>
                                                            <Form.Field error={this.state.checkedSemestersErr}>
                                                                <Checkbox
                                                                    checked={checkedSemesters.filter(e => e === el.studentStudyProgramSemesterId).length !== 0}
                                                                    onChange={(e, { checked }) => { this.handleCheckboxChange(el.studentStudyProgramSemesterId, checked); }}
                                                                />
                                                            </Form.Field>
                                                        </Form>

                                                    </Table.Cell>
                                                </Table.Row>))}
                                            </Table.Body>
                                        </Table>
                                    </Grid.Column>
                                    <Grid.Column>
                                        {newStudyProgram ?
                                            studentSemestersForSecondStudent.length !== 0 ? <Table celled selectable compact >
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell colSpan={2}>Semestar (akademska godina)</Table.HeaderCell>
                                                        <Table.HeaderCell>Broj semestra</Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body> {studentSemestersForSecondStudent.sort((a, b) => b.semester.academicYear.id - a.semester.academicYear.id).filter(e => e.semester.name.name !== 'ostalo').map((el, index) =>
                                                    (<Table.Row key={index}>
                                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                                            {el.semester.name.name} ({el.semester.academicYear.name})
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {el.studyProgramSemester.name}
                                                        </Table.Cell>
                                                    </Table.Row>))}
                                                </Table.Body>
                                            </Table> :
                                            <p>Nema podataka.</p> :
                                                <Message negative>
                                                <p>Za prikaz semestara odaberite studenta.</p>
                                            </Message>
                                        }
                                    </Grid.Column>
                                </Grid>}
                        </Segment>

                        <Segment clearing textAlign="center">
                            {/* <Button basic color="blue" onClick={() => { this.setState({ back: true }); }}>Odustani</Button> */}
                            <Button
                                basic
                                color="blue"
                                onClick={this.transferSemesters}
                            >Prebaci</Button>
                        </Segment>
                    </Segment.Group>
                    <ToastContainer hideProgressBar />
                </div>
            </div>
        );
    }
}

export default SemesterTransferSemesters;



// WEBPACK FOOTER //
// ./src/views/Admin/Transfer/SemesterTransferSemesters.js